import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { LuDownload } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Page, PageContent, PageTitleRow, PageTopBar } from '@/components/ui/page-layout';
import { CustomerApi } from 'API';
import { useAuthContext } from 'views/auth/Auth';

const useTenantHouseholdReport = (tenantGUID?: string) =>
    useQuery({
        queryKey: ['tenant', tenantGUID, 'householdReport'],
        queryFn: async () => {
            if (!tenantGUID) return;
            return await CustomerApi().householdReportForTenant(tenantGUID);
        },
        refetchOnWindowFocus: false,
        enabled: false,
    });

export const ReportsPage: React.FC = () => {
    const { currentTenant } = useAuthContext();
    const { isFetching, refetch: downloadTenantReport } = useTenantHouseholdReport(currentTenant?.tenantGUID);

    return (
        <Page>
            <PageTopBar />
            <PageTitleRow title="Reports" />
            <PageContent>
                <Card>
                    <CardHeader className="pt-6 pb-0">
                        <CardTitle className="font-heading font-medium">Household Report</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="flex items-center gap-3">
                            <Button
                                onClick={() => downloadTenantReport()}
                                disabled={!currentTenant?.tenantGUID || isFetching}
                            >
                                {isFetching && (
                                    <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
                                )}
                                <LuDownload className="mr-2 h-4 w-4" /> Download
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </PageContent>
        </Page>
    );
};
